import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";

import { listDocuments } from "@/api/documents";
import type { FilterState } from "@/types/domain";

export function useDocuments(filters: FilterState) {
  return useInfiniteQuery({
    queryKey: ["documents", filters],
    initialPageParam: null as string | null,
    queryFn: ({ pageParam, signal }) => listDocuments(filters, pageParam, 50, signal),
    getNextPageParam: (last) => last.nextToken ?? undefined,
    placeholderData: keepPreviousData,
  });
}
